import {
  BooleanField,
  Show,
  TextField,
  SimpleShowLayout,
  DateField,
  UrlField,
  NumberField,
  SelectField,
  ShowActions,
  RichTextField,
} from "react-admin";
import {FileInput} from "../fileinputs/eventFileUpload";

export const EventShow = (props) => {
  return (
    <Show {...props} >
      <SimpleShowLayout   >
        <TextField source="name" />
        <RichTextField source="description" />
        <TextField source="textDescription" multiline />
        <TextField source="type" />
        <TextField source="location" />
        <TextField source="city" />
        <TextField source="externalLink" />
        <DateField source="startDate" locales="en-IN" />
        <DateField source="endDate" locales="en-IN" />
        <FileInput source="images" title="Uploaded Files" />
      </SimpleShowLayout>
    </Show>
  );
};
